import { BottomNavigation, BottomNavigationAction, Box, Button } from '@mui/material';
import { CalendarToday } from '@mui/icons-material'; // Material UI'dan bir ikon örneği
import { useQuery } from "@tanstack/react-query";
import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import AnswersPages from "../../components/Answers/AnswersPages";
import PieCharts from "../../components/Charts/PieChart/PieChart";


//Icons
import { BsGraphUp, BsList, BsCalendar } from "react-icons/bs";
import { IoMdEye } from "react-icons/io";
import Layout from "../../layout/Layout";
import { FcComboChart } from "react-icons/fc";

//APIs
import Loader from "../../components/Loader/Loader";
import { getAnalysis } from "../../services/ApiServices";
import Error from "../Error/Error";
import { AiOutlineLineChart } from "react-icons/ai";
import AnalysisTypes from "../../components/Analysis/AnalysisTypes";

export default function Analysis() {
  const { id } = useParams();
  const [value, setValue] = React.useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [displayDate, setDisplayDate] = useState(null);
  const [displayStartDate, setDisplayStartDate] = useState(null);
  const [displayEndDate, setDisplayEndDate] = useState(null);
  const [apiStartDate, setApiStartDate] = useState(null);
  const [apiEndDate, setApiEndDate] = useState(null);
  const [filterApplied, setFilterApplied] = useState(false);

  const handleCalendarClick = () => {
    setIsOpen(prev => !prev);
  };

  // Tarihleri güncelleyen useEffect
  useEffect(() => {
    if (displayStartDate || displayEndDate) {
      setDisplayDate(`Başlangıç Tarihi: ${displayStartDate || 'Belirtilmedi'} - Bitiş Tarihi: ${displayEndDate || 'Belirtilmedi'}`);
    } else {
      setDisplayDate('');
    }
  }, [displayStartDate, displayEndDate]);

  // API isteği için useQuery
  const { isLoading, error, data } = useQuery(
    ['getAnalysis', id, apiStartDate, apiEndDate],
    () => getAnalysis(id, filterApplied ? apiStartDate : undefined, filterApplied ? apiEndDate : undefined),
    {
      enabled: !!id, // Sadece id varsa istek at
      cacheTime: 0,
    }
  );

  // Filtreleme butonuna tıklama işlevi
  const handleFilter = () => {
   
    setApiStartDate(displayStartDate); // API için tarihleri güncelle
    setApiEndDate(displayEndDate);
    setFilterApplied(true);
    setIsOpen(prev => !prev);
  };

  function TopMenu(value) {
    switch (value) {
      case 0:
        return (
          <div>
            <AnalysisTypes AnalysisData={data.data.responses} />
          </div>
        );
      case 1:
        return (
          <div>
            <AnswersPages id={id} />
          </div>
        );

      default:
        break;
    }
  }

  if (isLoading) return <Loader />;

  if (error)
    return (
      <Error
        error={error.message}
        code={error.request.status}
        text={"Giriş Ekranına Geri Dön "}
        historylink={"/"}
      />
    );

  if (data.data.responses.length === 0) {
    return (
      <Layout>
        <div className=" min-h-[calc(100vh-50px)] flex items-center justify-center flex-col">
          <div className="flex  justify-center items-center  flex-col -mt-16">
            <AiOutlineLineChart className="text-black/20 " size={230} />
            <div className="text-xl md:text-3xl font-bold text-black/20  ">
              Maalesef, Anket için veri bulunamadı.
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <>
      <Layout>
        <div className="flex w-full min-h-[calc(100vh-50px)]  bg-gray-100 flex-col items-center ">
          <div className="flex flex-col items-center text-left m-4 justify-center bg-white  border-2 rounded-lg md:min-w-[800px]">
            <div className="application">
              <Helmet>
                <meta charSet="utf-8" />
                <title> ↗ Analiz | Grafikler Ve Daha Fazlası</title>
              </Helmet>
            </div>
            <div className="bg-gray-50 w-full p-4">
            <div className="flex items-center justify-between w-full  mt-4 ml-2 pt-2">
              <div className="text-black/60 flex items-center">
                <a
                  className="m-1 ml-2"
                  style={{ display: "table-cell" }}
                  target="_blank"
                  href={process.env.REACT_APP_FRONT_URL + "/survey/" + id}
                  rel="noopener noreferrer"
                >
                  <IoMdEye
                    size={20}
                    className="cursor-pointer hover:text-gray-300 text-black"
                  />
                </a>
                <div className="text-black/60"> - {id} </div>
              </div>
              <div className="flex flex-col items-center cursor-pointer" onClick={handleCalendarClick} style={{marginTop:'2px',marginRight:'20px'}}>
                <BsCalendar className="text-xl text-gray-400 hover:text-blue-500 transition duration-200" />
                <span className="mt-1 text-gray-500 text-xs font-medium">Tarih Filtrele</span>
              </div>

            </div>
            {isOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="flex flex-col p-8 bg-white shadow-lg rounded-lg transition-all duration-700 ease-in-out transform scale-100 opacity-100">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-lg font-semibold text-gray-800">Tarih Filtreleme</h2>
                    <button onClick={() => setIsOpen(false)} className="text-gray-600 hover:text-gray-800">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="flex items-center justify-center mb-6 space-x-4">
                    <div className="flex flex-col space-y-2">
                      <label className="text-sm font-medium text-gray-800">Başlangıç Tarihi</label>
                      <input
                        type="date"
                        value={displayStartDate}
                        onChange={(e) => setDisplayStartDate(e.target.value)}
                        className="block w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring focus:ring-blue-500 focus:outline-none transition duration-200"
                      />
                    </div>

                    <div className="flex flex-col space-y-2">
                      <label className="text-sm font-medium text-gray-800">Bitiş Tarihi</label>
                      <input
                        type="date"
                        value={displayEndDate}
                        onChange={(e) => setDisplayEndDate(e.target.value)}
                        className="block w-full border border-gray-300 rounded-md p-2 shadow-sm focus:ring focus:ring-blue-500 focus:outline-none transition duration-200"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <Button
                      onClick={handleFilter}
                      variant="contained"
                      color="primary"
                      className="rounded-md shadow-lg transition duration-200 transform btn-filter"
                      style={{ backgroundColor: 'black', color: 'white', padding: '5px 25px', borderRadius:'10px' }}
                    >
                      Filtrele
                    </Button>
                  </div>
                </div>
              </div>
            )}

              <div className="flex flex-col items-start w-full border-t-2 mt-4 ml-2">
                <div className="text-3xl text-black/70 mt-2 font-bold">
                  {data.data.survey_title} 
                </div>
                <div className="flex items-center justify-between w-full mt-1 text-black/60">
                  <div className="text-md">
                    {data.data.survey_description}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-center md:m-0 m-6">
          <Box className="md:w-[800px] w-full">
            <BottomNavigation
              className="border-b-2 -rounded-2xl border-l-2 border-r-2"
              showLabels
              value={value}
              onChange={(_, newValue) => {
                setValue(newValue);
              }}
            >
              <BottomNavigationAction label="Grafikler" icon={<BsGraphUp />} />
              <BottomNavigationAction label="Sayfalar" icon={<BsList />} />
            </BottomNavigation>
            
          </Box>
        </div>
          <div className="w-full flex flex-col md:items-center md:justify-center">
            {TopMenu(value)}
          </div>
        </div>
      </Layout>
    </>
  );
}
